__turbopack_context__.v({
  "reasonForVisitIcon": "ReasonForVisit-module__dKZDZa__reasonForVisitIcon",
  "reasonForVisitIconBrokenTooth": "ReasonForVisit-module__dKZDZa__reasonForVisitIconBrokenTooth",
  "reasonForVisitIconDentalImplants": "ReasonForVisit-module__dKZDZa__reasonForVisitIconDentalImplants",
  "reasonForVisitIconDentures": "ReasonForVisit-module__dKZDZa__reasonForVisitIconDentures",
  "reasonForVisitIconEmergency": "ReasonForVisit-module__dKZDZa__reasonForVisitIconEmergency",
  "reasonForVisitIconMotto": "ReasonForVisit-module__dKZDZa__reasonForVisitIconMotto",
  "reasonForVisitIconOtherCheckup": "ReasonForVisit-module__dKZDZa__reasonForVisitIconOtherCheckup",
  "reasonMenuItem": "ReasonForVisit-module__dKZDZa__reasonMenuItem",
  "reasonMenuList": "ReasonForVisit-module__dKZDZa__reasonMenuList",
  "reasonMenuPaper": "ReasonForVisit-module__dKZDZa__reasonMenuPaper",
  "reasonSelectButton": "ReasonForVisit-module__dKZDZa__reasonSelectButton",
  "selected": "ReasonForVisit-module__dKZDZa__selected",
});
